import {
  RichTextNode,
  RichTextNodeType,
} from '@/common/components/RichText/RichTextService';

import Blockquote from '@/common/components/RichText/components/Blockquote/Blockquote';
import Heading from '@/common/components/RichText/components/Heading/Heading';
import Hr from '@/common/components/RichText/components/Hr/Hr';
import Hyperlink from '@/common/components/RichText/components/Hyperlink/Hyperlink';
import List from '@/common/components/RichText/components/List/List';
import Paragraph from '@/common/components/RichText/components/Paragraph/Paragraph';
import RichTextWrapper from './components/Wrapper/RichTextWrapper';
import { SxProps } from '@mui/material';

export interface RichTextProps {
  content: RichTextNode[];
  centered?: boolean;
  sx?: SxProps;
}

export default function RichText({ content, sx, centered }: RichTextProps) {
  if (!content || content.length === 0) return null;

  return (
    <RichTextWrapper>
      {content.map((node, index) => {
        switch (node.nodeType) {
          case RichTextNodeType.Paragraph:
            return <Paragraph sx={sx} key={index} node={node} />;
          case RichTextNodeType.Heading1:
          case RichTextNodeType.Heading2:
          case RichTextNodeType.Heading3:
          case RichTextNodeType.Heading4:
          case RichTextNodeType.Heading5:
          case RichTextNodeType.Heading6:
            return <Heading key={index} node={node} />;
          case RichTextNodeType.Hyperlink:
            return <Hyperlink key={index} node={node} />;
          case RichTextNodeType.EntryHyperlink:
            return <Hyperlink key={index} node={node} />;
          case RichTextNodeType.UnorderedList:
          case RichTextNodeType.OrderedList:
            return <List key={index} node={node} centered={centered} />;
          case RichTextNodeType.Blockquote:
            return <Blockquote key={index} node={node} />;
          case RichTextNodeType.Hr:
            return <Hr key={index} />;
          default:
            return null;
        }
      })}
    </RichTextWrapper>
  );
}
